/* Store-wide published text reviews: same source as the home page. */
(() => {
  'use strict';
  const selector = '.lvc-cro-store-trust';
  const endpoint = 'https://lvc-reviews.onrender.com/api/home/reviews?limit=3&page=1';
  let total = null;
  let pending = false;
  function label(n) {
    return 'Más de ' + new Intl.NumberFormat('es-ES').format(Math.floor(n / 100) * 100) + ' opiniones';
  }
  function render() {
    const text = total === null ? 'Opiniones de clientes' : label(total);
    document.querySelectorAll(selector).forEach(badge => {
      const copy = badge.querySelector('.lvc-trust-copy strong');
      if (!copy) return;
      if (copy.textContent !== text) copy.textContent = text;
      const accessible = 'Cinco estrellas. ' + text + ' sobre nuestra tienda. Desde 1950';
      if (badge.getAttribute('aria-label') !== accessible) badge.setAttribute('aria-label', accessible);
    });
    document.querySelectorAll('.lvc-rv-trust span:first-child').forEach(copy => {
      const value = '🏆 ' + text;
      if (copy.textContent !== value) copy.textContent = value;
    });
  }
  async function refresh() {
    if (pending || document.hidden) return;
    pending = true;
    try {
      const response = await fetch(endpoint, {cache: 'no-store'});
      if (!response.ok) throw new Error('reviews_unavailable');
      const data = await response.json();
      const value = Number(data.summary?.total);
      if (!data.ok || !Number.isSafeInteger(value) || value < 100) throw new Error('invalid_total');
      total = value;
      render();
    } catch (_) {
      // Keep the last verified total, or a neutral label before the first success.
    } finally { pending = false; }
  }
  function start() {
    render();
    refresh();
    new MutationObserver(render).observe(document.body, {subtree: true, childList: true});
    document.addEventListener('visibilitychange', refresh);
    setInterval(refresh, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();

